import React from 'react';
import styled from 'styled-components';
import { Warning } from '../../icons/Warning';
import { typography } from '../../theme';
import { colors } from '../../theme/color';

type Props = {
  error?: string | null;
  warning?: boolean;
  id: string;
};

export const InputError: React.FC<Props> = ({ error, warning = false, id, ...props }) => {
  return (
    <ErrorContainer id={id} aria-live="polite" {...props}>
      {error && (
        <Container>
          <StyledWarning warning={warning} />
          <Error warning={warning}>{error}</Error>
        </Container>
      )}
    </ErrorContainer>
  );
};

const Container = styled.div`
  margin-top: 10px;
  display: flex;
`;

const ErrorContainer = styled.div`
  width: 100%;
`;

const StyledWarning = styled(Warning)<{ warning: boolean }>`
  color: ${({ warning }) => (warning ? colors.textWarning : colors.textError)};
  width: 30px;
  height: 20px;
  margin-right: 5px;
  flex-shrink: 0;
`;

const Error = styled.p<{ warning: boolean }>`
  ${typography.paragraphMediumStyle}
  color: ${({ warning }) => (warning ? colors.textWarning : colors.textError)};
  margin: 0;
`;
